import { Base } from "../core/base.model";


export class TipoCliente extends Base {

    public id: number;
	public tipo:string;
	public estatus:string;

}

